export enum EHeatMapCategory {
  PRICE = 'price',
  RENT = 'rent',
  CAPRATE = 'caprate'
}
